import React, { useState, useEffect } from 'react';
import Header from './Header';
import Experiences from './Experiences';
import Schools from './Schools';
import Skills from './Skills';
import About from './About';
import i18n from "i18next";
import { withTranslation } from 'react-i18next';
import analytics from './Firebase';

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const langParam = queryParams.get('lang');
    let lng = langParam === 'full' ? 'full' : 'fr';

    // Fonction synchrone pour charger et fusionner les données
    const loadData = (currentLang) => {
      // Sécurité : on s'assure d'avoir un code à 2 lettres
      const lang = (currentLang || 'fr').split('-')[0];

      // Retrait des "await"
      let baseData = i18n.getResourceBundle(lang, 'julien');

      // Fallback de sécurité si le dictionnaire n'existe pas du tout
      if (!baseData) {
        baseData = i18n.getResourceBundle('fr', 'julien');
      }

      if (!baseData) return;

      if(lng === 'full') {
        const fullData = i18n.getResourceBundle(lang, 'full') || i18n.getResourceBundle('fr', 'full');

        if (fullData) {
          const uniqueSchools = new Set([...baseData.Schools, ...fullData.Schools]);
          baseData.Schools = [...uniqueSchools];

          const combinedExperiences = [...baseData.Experiences, ...fullData.Experiences];
          const uniqueExperiences = Array.from(
              new Map(combinedExperiences.map((exp) => [exp.companyName, exp])).values()
          );

          uniqueExperiences.sort((a, b) => b.start.localeCompare(a.start));
          baseData.Experiences = uniqueExperiences;
        }
      }
      setData({ ...baseData });
    };

    // Sécurisation de la langue du navigateur
    const browserLanguage = (navigator.language || navigator.userLanguage).split('-')[0];

    if (langParam != null && langParam !== 'full' && i18n.hasResourceBundle(langParam, 'julien')) {
      i18n.changeLanguage(langParam);
    } else if (i18n.hasResourceBundle(browserLanguage, 'julien')) {
      i18n.changeLanguage(browserLanguage);
    } else if (!i18n.language) {
      i18n.changeLanguage('fr');
    }

    loadData(i18n.language);

    const handleLanguageChange = (newLang) => {
      loadData(newLang);
    };

    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  if (!data) {
    return <div>Loading...</div>;
  }

  // Sécurité supplémentaire pour l'extraction des keys
  const langCode = (i18n.language || 'fr').split('-')[0];
  const keys = i18n.getResourceBundle(langCode, 'keys') || i18n.getResourceBundle('fr', 'keys');

  return (
      <div className="App">
        <Header data={data} keys={keys} />
        <Experiences data={data} keys={keys}/>
        <div className="right-column">
          <About data={data} keys={keys}/>
          <Schools data={data} keys={keys}/>
          <Skills data={data} keys={keys}/>
        </div>
      </div>
  );
}

export default withTranslation()(App);